import { toast } from "sonner";

export const LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_9bff75f8-eae1-4dc1-93fc-e7dbb5f2df9c/artifacts/b6302b5de3cde45f_Revive%20%26%20Drive%20Auto%20LLC%20Image.webp";

export const IMAGES = {
  heroVan:
    "https://images.unsplash.com/photo-1763377278900-0ce8242c5005?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxtZWNoYW5pYyUyMHZhbiUyMHJvYWRzaWRlfGVufDB8fHx8MTc5MjI3NjI4Mnww&ixlib=rb-4.1.0&q=85",
  engine:
    "https://images.pexels.com/photos/3807517/pexels-photo-3807517.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  charging:
    "https://images.pexels.com/photos/8478228/pexels-photo-8478228.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cooling:
    "https://images.pexels.com/photos/6720532/pexels-photo-6720532.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  roadside:
    "https://images.pexels.com/photos/18863497/pexels-photo-18863497.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  workshop:
    "https://images.pexels.com/photos/7006667/pexels-photo-7006667.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const BUSINESS_PHONE = "+15137802935";
export const BUSINESS_PHONE_DISPLAY = "(513) 780-2935";

export function handleCallClick() {
  if (BUSINESS_PHONE) {
    window.location.href = `tel:${BUSINESS_PHONE}`;
    return;
  }
  toast.info("Our direct dispatch line is being connected — send the form and we'll call you right back.");
  document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" });
}
